export const jarvisPrimeOnboardingConstants = {
  PRIME_RESET_ONBOARDING_DATA: "PRIME_RESET_ONBOARDING_DATA",
  PRIME_UPDATE_ONBOARDING_DATA: "PRIME_UPDATE_ONBOARDING_DATA",
  

  PRIME_ONBOARDING_DATA_API: "prime/investment/details",
  PRIME_ONBOARDING_DATA_SAGA: "PRIME_ONBOARDING_DATA_SAGA",
  PRIME_ONBOARDING_DATA_REQUEST: "PRIME_ONBOARDING_DATA_REQUEST",
  PRIME_ONBOARDING_DATA_RESPONSE: "PRIME_ONBOARDING_DATA_RESPONSE",
  
  PRIME_PORTFOLIO_DATA_API: "prime/investment/generate-portfolio",
  PRIME_PORTFOLIO_DATA_SAGA: "PRIME_PORTFOLIO_DATA_SAGA",
  PRIME_PORTFOLIO_DATA_REQUEST: "PRIME_PORTFOLIO_DATA_REQUEST",
  PRIME_PORTFOLIO_DATA_RESPONSE: "PRIME_PORTFOLIO_DATA_RESPONSE",

  PRICING_DATA_API: "v1/portfolio/pricing-details",
  PRICING_DATA_SAGA: "PRICING_DATA_SAGA",
  PRICING_DATA_REQUEST: "PRICING_DATA_REQUEST",
  PRICING_DATA_RESPONSE: "PRICING_DATA_RESPONSE",

  SUBMIT_RISK_ASSESSMENT_QUESTION_API:
    "prime/risk/submit-risk-assessment-questions",
    
  SUBMIT_PRIME_RISK_PROFILE_API: "prime/risk/confirm-risk-profile",

  SUBMIT_PRIME_INVESTMENT_API: "prime/investment/submit-investment-details",

  VERIFY_KYC_API: "v1/onboarding/verify-kyc",

  KYC_IMAGE_UPLOAD_API: "v1/onboarding/upload-kyc-docs",
  REVERIFY_KYC_API: "v1/onboarding/check-kyc-docs",

  INITIATE_DOCUMENT_SIGNING_API: "api/initate-sign",
  SEND_EMAIL_VERIFICATION_API: "customer/signup/send-email-verification-link",

  PRIME_CONFIRM_INVESTMENT_INFO_API: "prime/investment/confirm-investment",
};
